// extracted by mini-css-extract-plugin
export default {"container":"BetPlacedStatus_container__ZuXmZ","placed":"BetPlacedStatus_placed__vwHM-","rejected":"BetPlacedStatus_rejected__OO1PW","partial":"BetPlacedStatus_partial__CwXtQ"};